import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAppDispatch } from "redux/hooks";
import { setLastViewedFeature } from "redux/slices/clientLens";
import { ViewCasesDialog } from "../admin/management/ViewCases";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";
import SBRViewCasesDialog from "SBR/admin/ViewCases";
import { useShowSBR } from "SBR/useShowSBR";

export default function Cases() {
  const { lensId } = useParamNumbers(["lensId"]);
  const dispatch = useAppDispatch();
  const showSBR = useShowSBR();

  if (lensId === undefined) return <Navigate to="/lens" />;

  useEffect(() => {
    dispatch(setLastViewedFeature("cases"));
  }, []);

  return showSBR ? <SBRViewCasesDialog lensId={lensId} /> : <ViewCasesDialog lensId={lensId} />;
}
